const apiBaseURL = "https://mb.ask-me-2.com.au/api/look";
const appKey =
  "smart-$2y$10$RdYWP.Z6T1DFDjSSunimzOUcMDGIBmyqCQ11/Vof.idVxCY14h8ky-api";
var apiActiveURL = apiBaseURL;
var appId = 3;

const GOOGLE_MAP_KEY = "AIzaSyD7KP_KBsOP9zUUPn2JheVZgqLBq00F84o";
// AIzaSyAPA2PaJ3zo1in4Nl0IJ8Mssc7cseSaD4Y;
export { apiActiveURL, appKey, appId, GOOGLE_MAP_KEY };
